<div class="ui basic segment" [class.loading]="isLoading">
    <ui-button (click)="download()" [disabled]="!fileId" style="float: right">Download Results </ui-button>

    <h1 class="ui left floated header">Bulk Operation Results</h1>

    <div class="ui clear hidden double divider"></div>

    <div class="ui segment">
        The results of your bulk operation have been added to your original file for review.
        <br />
        <br />
        <strong>Processing Timestamp:</strong> {{ file?.createdAt | appDate: 'medium' }}
        <br />
        <br />
        Click "Download Results" above to view the results. If changes are required, update the resulting file and begin
        the bulk operation again.
    </div>
    <div class="ui clear hidden double divider"></div>
</div>
